module.exports = __webpack_public_path__ + "img/pethouse22.c1c784de.jpg";